import { adminSearchClients } from '@pro-sto/api-client';
import type { ClientSearchResultDto } from '@pro-sto/api-client';
import { normalizePhoneToE164 } from './utils';

/** Ищет клиента с точно тем же номером (E.164). */
export const findClientByExactPhone = async (
  phone: string,
): Promise<ClientSearchResultDto | null> => {
  const e164 = normalizePhoneToE164(phone);
  if (!e164) return null;

  const digits = e164.replace(/\D/g, '');
  const searchDigits = digits.startsWith('7') ? digits.slice(1) : digits;

  const results = await adminSearchClients({ phone: searchDigits, limit: 10 });
  return (
    results.find((client) => normalizePhoneToE164(client.phone) === e164) ?? null
  );
};
